import React, { Component } from "react";
import "./SelectInput.less";

class SelectInput extends Component {
  render() {
    const { label, name, value, onChange, options = [], required = false, error } = this.props;

    return (
      <div className="select-input">
        <label htmlFor={name} className={required ? "required" : ""}>
          {required && <span className="select-input__required">*</span>} {label}
        </label>
        <div className="select-input__wrapper">
          <select
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            className={error ? "select-input__error" : ""}
          >
            <option value="">Seleccionar</option>
            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        {error && <p className="select-input__error-message">{error}</p>}
      </div>
    );
  }
}

export default SelectInput;